import React from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import { makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import PartyDetailsSheet from "../PartyDetails/PartyDetailsSheet"

const useStyles = makeStyles(() => ({
    dialogContent: {
        marginBottom: "20px",
        minWidth: "500px"
    }
}))

const FinancialResponsibleDialog = (props) => {
    const classes = useStyles()
    const { t } = useTranslation()
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="financial-responsible-dialog"
            keepMounted={false}
            maxWidth="sm"
        >
            <DialogTitle
                className={["blueText", "subtitleSize"].join(" ")}
                id="financial-responsible-dialog"
            >
                {t("financial_responsible")}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <PartyDetailsSheet party={props.party} />
            </DialogContent>
        </Dialog>
    )
}

export default FinancialResponsibleDialog
